/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListContact } from '../../models/api-response-list-contact';

export interface ListContacts$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function listContacts(http: HttpClient, rootUrl: string, params: ListContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListContact>> {
  const rb = new RequestBuilder(rootUrl, listContacts.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListContact>;
    })
  );
}

listContacts.PATH = '/v1/api/ui/contacts/list';
